import { render, staticRenderFns } from "./IFAboutTheData.vue?vue&type=template&id=43093ef0"
import script from "./IFAboutTheData.vue?vue&type=script&lang=js"
export * from "./IFAboutTheData.vue?vue&type=script&lang=js"
import style0 from "./IFAboutTheData.vue?vue&type=style&index=0&id=43093ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports